import type React from 'react';

import type { Body, Meta, Uppy } from '@uppy/core';

import { Button } from '@change-corgi/design-system-legacy/components/actions';

import { CustomFileInput } from './CustomFileInputSunrise';

type Props = {
	uppy: Uppy<Meta, Body>;
	fileInputId: string;
	onButtonClick?: () => void;
	uploadButtonText?: string;
};

export const AccessibleFileInputWrapper: React.FC<Props> = ({
	uppy,
	fileInputId,
	onButtonClick,
	uploadButtonText = 'Upload',
}) => {
	/* FIXME we should not override the Button component => use buttonResetStyles instead */
	const buttonComponentOverrides = {
		as: 'label',
		htmlFor: fileInputId,
	} as unknown as EmptyProps;

	return (
		<>
			<CustomFileInput onButtonClick={onButtonClick} fileInputId={fileInputId} uppy={uppy} />
			<Button
				{...buttonComponentOverrides}
				tabIndex={-1}
				aria-controls={fileInputId}
				className="image-uploader-upload-button"
			>
				{uploadButtonText}
			</Button>
		</>
	);
};
